// extracted by mini-css-extract-plugin
module.exports = {"nonMobileWrapper":"_8f3ae762","isMobileWrapper":"_4d3d4717"};